export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'orders-change-group-modal';

export const REQUIRED_FIELDS = ['group_id'];

export const FORM_FIELDS = ['group_id'];
